<template>
  <map-container :fluid="false">
    <the-disclaimer />
    <map-getter
      v-slot="{ map, popup }"
      type="oecd"
      theme="light"
      :zoom="1.2"
      :minZoom="1.2"
      :maxZoom="5"
      :center="[0, 40]"
    >
      <the-map
        :map="map"
        :popup="popup"
        :minmax="minmax"
        :data="selectedData"
        :variable="selectedOption"
        @handle-map-value="handleMapValue"
      ></the-map>
    </map-getter>
    <map-controls>
      <map-control>
        <ButtonGroup
          v-model="selectedOption"
          :options="options"
          :small="true"
        ></ButtonGroup>
      </map-control>
      <map-control bottom><MapLegend :legend="mapLegend" /></map-control>
    </map-controls>
  </map-container>
</template>

<script>
import {
  MapContainer,
  MapGetter,
  MapControls,
  MapLegend,
  MapControl,
} from "@international-energy-agency/vue-ui/maps";
import { ButtonGroup } from "@international-energy-agency/vue-ui";
import TheMap from "./world/components/TheMap";
import TheDisclaimer from "./world/components/TheDisclaimer";
import carbon from "./world/assets/environmental.json";
import tax from "./world/assets/taxes.json";
import regulation from "./world/assets/regulations.json";
import price from "./world/assets/prices.json";
import { colorByVariable } from "./util";
export default {
  name: "WorldMap",
  components: {
    MapContainer,
    TheMap,
    MapGetter,
    TheDisclaimer,
    MapControls,
    MapControl,
    MapLegend,
    ButtonGroup,
  },
  data() {
    return {
      carbon,
      tax,
      regulation,
      price,
      selectedOption: "price",
      mapValue: null,
      options: [
        { value: "price", label: "Gasoline price" },
        { value: "regulation", label: "Level of regulation for gasoline" },
        { value: "tax", label: "Share of taxes in total gasoline price" },
        {
          value: "carbon",
          label: "Share of carbon taxes in total gasoline price",
        },
      ],
    };
  },
  computed: {
    mapLegend() {
      const { selectedOption, minmax } = this;
      let colors = colorByVariable[selectedOption];
      let title = {
        price: "USD/litre",
        tax: "%",
        carbon: "%",
      };
      let regulationLegend = [
        "End-user price is fixed",
        "End-user price is not fully fixed nor liberalized",
        "End-user price is fully liberalized",
      ];
      return selectedOption === "regulation"
        ? [
            {
              type: "category",
              title: " ",
              items: colors.map((d, i) => ({
                label: regulationLegend[i],
                color: d,
              })),
            },
          ]
        : [
            {
              title: title[selectedOption],
              labels: minmax,
              type: "continuous",
              colors: colors,
              value: this.mapValue,
            },
          ];
    },
    selectedData() {
      const { selectedOption } = this;
      return this[selectedOption];
    },
    minmax() {
      const { selectedOption, selectedData } = this;
      return selectedOption === "price" || selectedOption === "tax" || selectedOption === "carbon"
        ? [0, Math.max(...selectedData.map((d) => d.value))]
        : selectedOption === "carbon"
        ? [0, 100]
        : [];
    },
  },
  methods: {
    handleMapValue(value) {
      this.mapValue = value;
    },
  },
};
</script>

<style>
.map-control__inner .a-input {
  display: flex;
  flex-flow: column;
}
.map-control__inner .a-input button:not(:first-child) {
  margin-top: -1px;
}
.legend-items {
  max-width: unset !important;
}
</style>
